/**
 * TextGeometry component for A-Frame.
 */
var debug = AFRAME.utils.debug;

var error = debug('aframe-text-component:error');

var fontLoader = new THREE.FontLoader();

AFRAME.registerComponent('text-geometry', {
  schema: {
    bevelEnabled: {default: false},
    bevelSize: {default: 8, min: 0},
    bevelThickness: {default: 12, min: 0},
    curveSegments: {default: 12, min: 0},
    font: {type: 'asset', default: 'https://rawgit.com/ngokevin/kframe/master/components/text-geometry/lib/helvetiker_regular.typeface.json'},
    height: {default: 0.05, min: 0},
    size: {default: 0.5, min: 0},
    style: {default: 'normal', oneOf: ['normal', 'italics']},
    weight: {default: 'normal', oneOf: ['normal', 'bold']},
    value: {default: ''}
  },

  /**
   * Called when component is attached and when component data changes.
   * Generally modifies the entity based on the data.
   */
  update: function (oldData) {
    const data = this.data;
    const el = this.el;

    if (!data.value) { return; }

    let mesh = el.getObject3D('mesh');
    if (!mesh) {
      mesh = new THREE.Mesh();
      el.setObject3D('mesh', mesh);
    }

    if (data.font.constructor === String) {
      // Load typeface.json font.
      fontLoader.load(data.font, function (response) {
        const textData = AFRAME.utils.clone(data);
        textData.font = response;
        mesh.geometry = new THREE.TextGeometry(data.value, textData);
        mesh.geometry.translate(-0.18, 0, -0.07);
      });
    } else if (data.font.constructor === Object) {
      // Set font if already have a typeface.json through setAttribute.
      mesh.geometry = new THREE.TextGeometry(data.value, data);
      mesh.geometry.translate(-0.18, 0, -0.07);
    } else {
      error('Must provide `font` (typeface.json) or `fontPath` (string) to text component.');
    }
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['text-geometry',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
